import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("osb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (id) => `${API}/files/${id}`;

// Resolve a media source: uploaded file takes priority, else external url.
export const media = (fileId, url) => (fileId ? fileUrl(fileId) : url || "");

// Generic cover fallback so we never render <img src="">.
export const FALLBACK_IMG =
  "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxhZnJpY2FuJTIwYW1lcmljYW4lMjBwb2RjYXN0JTIwbWljcm9waG9uZXxlbnwwfHx8fDE3ODg5MTY4MjB8MA&ixlib=rb-4.1.0&q=85";

export const img = (fileId, url) => media(fileId, url) || FALLBACK_IMG;
